import RequestAPI from '../index'
import config from 'Config/config'

const apiServer = new RequestAPI(config.apiServer)
export const apiMockupServer = new RequestAPI(config.apiMockupServer)
export default apiServer
